import styled from 'foundations-theming/utils';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const HoverCircle = styled.div.withConfig({
  displayName: "OnFillCloseButton__HoverCircle"
})([".hs-private.hs-private.hs-private &{display:inline-flex;align-items:center;justify-content:center;border-radius:", ";padding:", ";transition:background-color 0.2s ease;cursor:pointer;}.hs-private.hs-private.hs-private &:hover{background-color:", ";}"], ({
  theme
}) => theme.borderRadius['full'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.color['fill-accent-blue-hover']);
/**
 * A close button intended to sit on a filled (accent-colored) surface: a white
 * "X" with a circular `fill-accent-blue-hover` hover state. The transparent-black
 * hover of the foundations `CloseButton` is hard to see on salient backgrounds.
 */
const OnFillCloseButton = ({
  'aria-label': ariaLabel,
  onClick,
  'data-test-id': dataTestId
}) => /*#__PURE__*/_jsx(Clickable, {
  "aria-label": ariaLabel,
  "data-action": "close",
  "data-test-id": dataTestId,
  display: "inline-flex",
  onClick: onClick,
  children: /*#__PURE__*/_jsx(HoverCircle, {
    children: /*#__PURE__*/_jsx(RemoveIcon, {
      color: "text-core-on-fill-default",
      size: "100"
    })
  })
});
export default OnFillCloseButton;